import { render, staticRenderFns } from "./AccountingTargetPage.vue?vue&type=template&id=640b5e2e&scoped=true"
import script from "./AccountingTargetPage.vue?vue&type=script&lang=js"
export * from "./AccountingTargetPage.vue?vue&type=script&lang=js"
import style0 from "./AccountingTargetPage.vue?vue&type=style&index=0&id=640b5e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b5e2e",
  null
  
)

export default component.exports